
// 数据参数
export const ZifData = {
    Width: 20000,
    Height: 13408,
    voxelResolution: 3.25,
    Coronal: {
        count: 700,
        zif_start: '00001',
        zif_end: '00700'
    },
    Sagittal: {
        count: 45,
        zif_start: '00001',
        zif_end: '00045'
    },
    Horizontal: {
        count: 367,
        zif_start: '00681',
        zif_end: '08001'
    }
}